import React, { Fragment, useEffect, useState } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Col, Row} from "react-bootstrap";
import cx from "classnames";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import requestApi from "../../../../services/requestApi.service";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import {CopyToClipboard} from "react-copy-to-clipboard";
import QRCode from "qrcode.react";
import WebsiteWidget from "./WebsiteWidget";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {parseJSON,handleErrorResponse} from "../../../../Common/Appcommon";
const ControllerComp = Controller;

const LinkGenerator = (props) => {
    const [defaultValue, setDefaultValues] = useState({});
    const [redirectId, setRedirectId] = useState("");
    const [inputData, setInputData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [isCopied, setTextCopied] = useState(false)
    const [redirectUrl, setRedirectUrl] = useState("");
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    let ctName = props.ctName;
    useEffect(() => {
        //if (userPrefersDark) document.body.classList.add("dark-theme");
        (async () => {
            await loadLinkGeneratorData();
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);
    const loadLinkGeneratorData = async (data) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "GET_LINK_GENERATOR",
            "NAME" : ctName
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let data = res.data;
            if(data.length > 0){
                let dataStr = data[0]['input_info'];
                let redirectId = data[0]['redirect_id'];
                setRedirectId(redirectId);
                if(dataStr !== "" && dataStr !== null){
                    let dataObj = parseJSON(dataStr);
                    if(Object.keys(dataObj).length > 0) {
                        setInputData(dataObj);
                        forceUpdate();
                    }
                }
            }
        }
    }
    const linkGenForm = useForm({});
    const { register, handleSubmit, control, formState: { errors } } = linkGenForm;
    const submitForm = async (data) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "SAVE_LINK_GENERATOR",
            "DATA" : inputData,
            "NAME" : ctName
        }
        let res = await requestApi.processServerRequest(params,"WebV2","post");
        if(res.issuccess){
            let redirectId = res.data[0];
            let redirectUrl = res.data[1];
            setRedirectUrl(redirectUrl);
            setRedirectId(redirectId);
            setTextCopied(false);
            setShowModal(true);
        }else{
            handleErrorResponse(res.errormsg);
        }
    }
    const handleInputChange = (e) => {
        let tmpInputData = inputData;
        tmpInputData[e.target.name] = e.target.value;
        setInputData(tmpInputData);
        forceUpdate();
    }
    const toggleModalVisiblity = () => {
        setShowModal(!showModal);
    }
    let shortLink = process.env.REACT_APP_SHORT_URL;
    shortLink += "/r/"+redirectId;
    if(redirectUrl != "" && redirectUrl != undefined){
         shortLink = redirectUrl;
    }
   
    return (
        <>
            <Fragment>
                <div className={'link-generator-container'}>
                    <Modal className={'webiste-chat-modal'} isOpen={showModal}  toggle={toggleModalVisiblity} >
                        <ModalHeader toggle={toggleModalVisiblity}>
                            {"Your WhatsApp link has been generated!"}
                        </ModalHeader>
                        <ModalBody>
                            <div className={'p-4'}>
                                <div className={'link-gen-content'}>
                                    <div className={'website-script-content bg-active flex flex-col items-center justify-center gap-y-3 mx-6'}>
                                        <p>
                                            Copy it and share it via emails, messaging, your website or even social media. Your desired users can contact you in just one click. Download the QR code to share it anywhere.
                                        </p>
                                        <div className={'flex justify-center items-center break-words flex-wrap'}>
                                            <div className="h-10 w-10 mb-2">
                                                <FontAwesomeIcon className={'wp-brand'} icon={faWhatsapp} />
                                            </div>
                                            <a target={"_blank"} href={shortLink} className={'cursor-pointer font-medium text-xl ml-2.5 break-all text-center'}>{shortLink}</a>
                                        </div>
                                        <div className={'scanner text-center'}>
                                            <QRCode
                                                value={shortLink}/>
                                        </div>
                                    </div>
                                    <div className="flex flex-col mx-6">
                                        <hr className="m-0" />
                                        <div className="flex justify-end gap-x-2 my-4">
                                            <CopyToClipboard onCopy={(e) => {setTextCopied(true)}} text={shortLink}>
                                            <button
                                                className="hover:bg-green-medium-dark border-slate-300  rounded-full font-semibold py-1.5 px-3 text-white bg-green-dark"
                                                data-cy="copy-short-link">{isCopied ? "Copied!" : "Copy Link"}
                                            </button>
                                            </CopyToClipboard>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </ModalBody>
                    </Modal>
                    <Row>
                        <Col md={'6'}>
                            <form name={'website_chat'} onSubmit={handleSubmit(submitForm)}>
                                <div className={'website-chat-form'}>
                                    <div className={'cursor-pointer mb-3 goback-btn'} onClick={(e) => {props.onBackAction(e)}}>
                                        <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                                    </div>
                                    <div className={'website-chat-header'}>
                                        <div className={'d-flex-alone align-items-center'}>
                                            <div className={'image-container'}>
                                                <FontAwesomeIcon className={`phone-icon`} icon={faWhatsapp}/>
                                            </div>
                                            <div className={"header-text"}>
                                                Generate WhatsApp Live Chat Link
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'website-chat-content'}>
                                        <Row className={'mb-3'}>

                                            <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                                <label className={'group-header-lbl'} htmlFor="wa_number">Enter your WhatsApp number*</label>
                                                <ControllerComp
                                                    name="wa_number"
                                                    control={control}
                                                    rules={{ required: inputData.wa_number !== undefined && inputData.wa_number !== "" ? false : "WhatsApp Number is required"}}
                                                    render={({ field }) => {
                                                        return (
                                                            <input
                                                                {...field}
                                                                type="number"
                                                                name="wa_number"
                                                                id="whatsapp-number"
                                                                value={inputData.wa_number !== undefined ? inputData.wa_number : ""}
                                                                autoComplete={"off"}
                                                                placeholder={"Your phone number"}
                                                                onChange={(e) => {
                                                                    handleInputChange(e);
                                                                    field.onChange(e);
                                                                }}
                                                                className={`form-control ${errors.wa_number ? 'is-invalid' : ''}`}
                                                            />
                                                        );
                                                    }}
                                                />
                                                <p className="text-sm text-gray-400">Example: 919998887776</p>
                                                {errors.wa_number && <em className={`error invalid-feedback`}>{errors.wa_number.message}</em>}
                                            </Col>
                                        </Row>
                                        <Row className={'mb-3'}>

                                            <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                                <label className={'group-header-lbl'} htmlFor="welcomeTxt">Add your custom message*</label>
                                                <ControllerComp
                                                    name="welcomeTxt"
                                                    control={control}
                                                    rules={{ required: inputData.welcomeTxt !== undefined && inputData.welcomeTxt !== "" ? false : "Welcome Text is required"}}
                                                    render={({ field }) => {
                                                        return (
                                                            <textarea
                                                                {...field}
                                                                name="welcomeTxt"
                                                                id="welcome-text"
                                                                value={inputData.welcomeTxt !== undefined ? inputData.welcomeTxt : ""}
                                                                autoComplete={"off"}
                                                                placeholder={"Add custom message that users will send to you"}
                                                                onChange={(e) => {
                                                                    handleInputChange(e);
                                                                    field.onChange(e);
                                                                }}
                                                                className={`form-control ${errors.welcomeTxt ? 'is-invalid' : ''}`}
                                                            />
                                                        );
                                                    }}
                                                />
                                                <p className="text-sm text-gray-400">Example: “Hello, I am interested to know more about your business”.</p>
                                                {errors.welcomeTxt && <em className={`error invalid-feedback`}>{errors.welcomeTxt.message}</em>}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="10" className={cx('pr-0 d-grid margin-left-3')}>
                                                <Button color={'success'} >
                                                    Generate my link
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </form>
                        </Col>
                        <Col md={'6'} className={'link-generator-preview'}>
                            {Object.keys(inputData).length > 0  && <WebsiteWidget isPreviewWidget={true} isLinkGenerator={true} widgetData={inputData} />}
                        </Col>
                    </Row>

                </div>
            </Fragment>
        </>
    )
}

export default LinkGenerator;
